import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["projectSelect", "objectiveSelect"]
  static values = { missionId: Number, embedded: Boolean }

  projectChanged(event) {
    const projectId = event.target.value

    // Fetch objectives for the selected project, or client-level objectives when no project.
    // Carry the embedded flag through so the re-rendered Slim Select portals into the
    // correct dialog (standalone tracking-settings dialog vs. the chart-preview dialog).
    const embeddedParam = this.embeddedValue ? '&embedded=true' : ''
    const url = `/missions/${this.missionIdValue}/tasks/objectives_for_project?project_id=${projectId || ''}${embeddedParam}`

    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
  }
}
